export default __webpack_public_path__ + "static/feature-banner-destinations-asia-dbf093cabfa74830d8c1806d9a24cf15.jpg";